'use strict'

Backbone = require 'backbone'
Backbone.$ = window.$
window.Backbone = Backbone